import { Link } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const WHERE = { customer: ["/dashboard?tab=account", "My Bookings → Account"], companion: ["/companion?tab=security", "Dashboard → Password"], moderator: ["/admin?tab=password", "Admin → Password"] };

export const MustChangeBanner = () => {
  const { user } = useAuth();
  if (!user?.must_change_password) return null;
  const [to, label] = WHERE[user.role] || ["/", ""];
  return (
    <div className="bg-amber-50 border-b border-amber-200 text-amber-900 text-sm px-4 py-2.5 flex flex-wrap justify-center items-center gap-2" data-testid="must-change-password-banner">
      <KeyRound size={16} />You are using a temporary password. Please set a new one now:
      <Link to={to} className="font-semibold underline" data-testid="must-change-password-link">{label}</Link>
    </div>
  );
};
